import { render } from "./ContributorModal.vue?vue&type=template&id=588cfd84&scoped=true"
import script from "./ContributorModal.vue?vue&type=script&lang=js"
export * from "./ContributorModal.vue?vue&type=script&lang=js"

import "./ContributorModal.vue?vue&type=style&index=0&id=588cfd84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-588cfd84"]])

export default __exports__